import { gql } from '@apollo/client';

const sendAgentsToCentralNodeQuery = gql`
  mutation ($agentID: Int) {
    sendAgentsToCentralNode(agentID: $agentID)
  }
`;
export default sendAgentsToCentralNodeQuery;
